export default __webpack_public_path__ + "static/media/arrow-left.8864dc73.svg";